import { RequestDocument, Variables } from "graphql-request/src/types";
import { configureRequest } from "../utils/request";
import { getClient } from "./client";

export async function makeGQLRequest<T, V extends Variables = Variables>(
  query: RequestDocument,
  variables?: V,
) {
  return configureRequest(() => getClient().request<T>(query, variables));
}
